import { useState } from 'react';
import { ModuleData } from '../../Types/containerV2';
import { isCookieButtonModuleContent } from '../../Types/containerV2/modules/cookieButton';
import ModuleActionSurface from './ModuleActionSurface';
import { useGlobalState } from '../../Contexts/globalStateContext';
import './CookieButtonModule.scss';

type CookieButtonModuleProps = {
	module: ModuleData;
};

const CookieButtonModule = ({ module }: CookieButtonModuleProps) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const { setHasAcceptedCookies } = useGlobalState();

	if (!isCookieButtonModuleContent(module.content)) {
		return null;
	}

	const content = module.content;

	const setCookieConsent = async () => {
		if (isSubmitting) {
			return;
		}

		const accepted = !content.isRejectButton;
		setIsSubmitting(true);
		await setHasAcceptedCookies(accepted);
		setIsSubmitting(false);
	};

	return (
		<button type='button' className='biz-cookie-button-module__button' onClick={setCookieConsent} disabled={isSubmitting}>
			<ModuleActionSurface
				className='biz-cookie-button-module'
				label={content.buttonText || (content.isRejectButton ? 'Only necessary' : 'Allow all')}
				disabled={isSubmitting}
			/>
		</button>
	);
};

export default CookieButtonModule;
